import { createContext, useContext } from 'react';

import type { Recommender } from '@coursera/event-pulse-types';

import type { CollectionEntity } from 'bundles/collections-carousel/types/CarouselCollection';

export type RelatedProgramsData = {
  roleName: string;
  collectionId: string;
  collectionEntities: CollectionEntity[];
};

export type RelatedProgramsContextType = {
  loading?: boolean;
  data?: RelatedProgramsData;
  eventingRecommender?: Recommender;
};

const RelatedProgramsDataContext = createContext<RelatedProgramsContextType | undefined>(undefined);

export const useRelatedProgramsData = () => {
  return useContext(RelatedProgramsDataContext) || {};
};

export default RelatedProgramsDataContext;
